import ajax from '@/utils/ajax';

export const head = '/web';
// const applets = '/applets';

// 获取全部ai应用列表
export const getAiBotList = () => ajax(`${head}/v1/ai-app/list`, '', 'GET');
// 获取指定ai应用
export const getAiBotAppoint = (appCode) => ajax(`${head}/v1/ai-app/code/${appCode}`, '', 'GET');
// 获取当前ai信息
export const getAiInfo = (appId) => ajax(`${head}/v1/ai-app/${appId}`, '', 'GET');

// 获取会话id sessionId
export const getAiSessionId = (appId, businessId) => ajax(`${head}/v1/ai-session/info?appId=${appId}&businessId=${businessId}`, '', 'GET');

// 开始会话连接
export const openAiConnect = (data) => ajax('/tool/v1/ai-sse/connect', data, 'post', { responseType: 'stream' });

// 停止回答
export const stopAiConnect = (connectId) => ajax(`${head}/v1/ai-sse/stop-stream/${connectId}`, '', 'GET');

export const getHistoryAiInfo = (sessionId, pageNum, pageSize) => ajax(`${head}/v1/ai-session/history/session-record?sessionId=${sessionId}&pageNum=${pageNum}&pageSize=${pageSize}`, '', 'GET');

// 修改需要按钮点击状态
export const reqAISessionClickStatus = ({ clickStatus, connectId, sourcePort }) => (ajax(`${head}/v1/ai-session/edit-click-status?clickStatus=${clickStatus}&connectId=${connectId}&sourcePort=${sourcePort}`, '', 'POST'));

// 预制学习报告的内容
export const preReport = (userProductId) => ajax(`${head}/v1/user-learn-report/ai?userProductId=${userProductId}`, '', 'GET');

